import { createContext, useContext, useEffect, useState } from "react";
import { TRANSLATIONS } from "./translations";

const LanguageContext = createContext(null);
const HTML_LANG = { es: "es-AR", pt: "pt-BR", en: "en" };

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      const saved = localStorage.getItem("federasol_lang");
      return saved && TRANSLATIONS[saved] ? saved : "es";
    } catch {
      return "es";
    }
  });

  const setLang = (l) => {
    if (!TRANSLATIONS[l]) return;
    setLangState(l);
    try {
      localStorage.setItem("federasol_lang", l);
    } catch {}
  };

  useEffect(() => {
    document.documentElement.lang = HTML_LANG[lang] || "es-AR";
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, T: TRANSLATIONS[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
